import {apiFetch} from "../../api";
import {BASE_URL as u} from "../../../commonUrls";
const BASE_URL = `${u}/transaction`;
//const USER_ID = "u-c136202b-94f4-4e51-aa0b-72db0503c362";

// Expense
export async function addExpense(data){
  return apiFetch(`${BASE_URL}/addExpense`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(data)
  });
}

// Income
export async function addIncome(data){
  return apiFetch(`${BASE_URL}/addIncome`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(data)
  });
}

// Transfer
export async function addTransfer(data){
  return apiFetch(`${BASE_URL}/transfer`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(data)
  });
}

export async function getAllTransactions(){
  const res = await apiFetch(`${BASE_URL}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function deleteTransaction(id){
  return apiFetch(`${BASE_URL}/${id}`,{
    method:"DELETE"
  });
}

export async function updateExpense(id, data) {
  return apiFetch(`${BASE_URL}/expense/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function updateIncome(id, data) {
  return apiFetch(`${BASE_URL}/income/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function updateTransfer(id, data) {
  return apiFetch(`${BASE_URL}/transfer/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function splitTransaction(data) {
  return apiFetch(`${BASE_URL}/split`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}
